import React from "react";
import "./Legal.css";
import logoBota from "../../assets/img/Frame.png";
import backgroundLogo from "../../assets/img/backgroundLogo.jpg";

export default function PrivacyPolicy() {
  return (
    <div
      className='legal-page'
      style={{ backgroundImage: `url(${backgroundLogo})` }}
    >
      <div className='legal-inner'>
        <a href='/login' className='legal-back'>&larr; Quay lại đăng nhập</a>
        <div className='legal-card'>
          <div className='legal-card-body'>
            <div className='legal-header'>
              <a href='/login' className='legal-logo'>
                <img src={logoBota} alt='Bota.vn' style={{ maxHeight: 52 }} />
              </a>
              <h1 className='legal-title'>Chính sách quyền riêng tư</h1>
              <div className='legal-updated'>Cập nhật lần cuối: 01/03/2026</div>
            </div>

            <div className='legal-content'>
              <p>
                Chào mừng bạn đến với connect.mybota.vn — nền tảng quản lý bán hàng đa kênh do Bota.vn xây dựng.
                Chúng tôi cam kết bảo vệ quyền riêng tư và thông tin cá nhân của bạn. Chính sách này giải thích
                cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ dữ liệu khi bạn sử dụng connect.mybota.vn.
              </p>

              <h2>1. Thông tin chúng tôi thu thập</h2>
              <p>Khi bạn sử dụng dịch vụ connect.mybota.vn, chúng tôi có thể thu thập các loại thông tin sau:</p>
              <ul>
                <li>
                  <strong>Thông tin tài khoản:</strong> Họ tên, địa chỉ email, số điện thoại,
                  tên doanh nghiệp khi bạn đăng ký tài khoản.
                </li>
                <li>
                  <strong>Thông tin cửa hàng:</strong> Dữ liệu liên kết từ các sàn thương mại điện tử
                  (Shopee, Lazada, TikTok Shop, Sendo) bao gồm thông tin sản phẩm, đơn hàng, kho hàng.
                </li>
                <li>
                  <strong>Thông tin vận chuyển:</strong> Dữ liệu kết nối với các đơn vị vận chuyển
                  (GHN, Viettel Post, SPX Express, Grab Express, v.v.) để quản lý giao hàng.
                </li>
                <li>
                  <strong>Thông tin sử dụng:</strong> Dữ liệu về cách bạn tương tác với connect.mybota.vn,
                  bao gồm trang đã truy cập, tính năng đã sử dụng, thời gian truy cập.
                </li>
                <li>
                  <strong>Thông tin kỹ thuật:</strong> Địa chỉ IP, loại trình duyệt, hệ điều hành,
                  thiết bị truy cập.
                </li>
              </ul>

              <h2>2. Mục đích sử dụng thông tin</h2>
              <p>Chúng tôi sử dụng thông tin thu thập được cho các mục đích sau:</p>
              <ul>
                <li>Cung cấp, vận hành và cải thiện dịch vụ quản lý bán hàng đa kênh.</li>
                <li>Đồng bộ và quản lý đơn hàng, sản phẩm, kho hàng giữa các sàn thương mại điện tử.</li>
                <li>Kết nối và xử lý vận chuyển với các đơn vị giao hàng.</li>
                <li>Gửi thông báo quan trọng về tài khoản, cập nhật dịch vụ.</li>
                <li>Hỗ trợ kỹ thuật và giải quyết vấn đề.</li>
                <li>Phân tích dữ liệu để nâng cao trải nghiệm người dùng.</li>
              </ul>

              <h2>3. Chia sẻ thông tin</h2>
              <p>Chúng tôi <strong>không</strong> bán hoặc cho thuê thông tin cá nhân của bạn. Thông tin chỉ được chia sẻ trong các trường hợp sau:</p>
              <ul>
                <li>
                  <strong>Đối tác sàn TMDT:</strong> Khi bạn liên kết tài khoản sàn thương mại điện tử,
                  chúng tôi truyền tải dữ liệu cần thiết qua API chính thức của các sàn.
                </li>
                <li>
                  <strong>Đơn vị vận chuyển:</strong> Thông tin giao hàng (địa chỉ nhận, số điện thoại người nhận)
                  được gửi đến đơn vị vận chuyển khi bạn tạo vận đơn.
                </li>
                <li>
                  <strong>Yêu cầu pháp lý:</strong> Khi có yêu cầu từ cơ quan nhà nước có thẩm quyền
                  theo quy định pháp luật Việt Nam.
                </li>
              </ul>

              <h2>4. Bảo mật dữ liệu</h2>
              <p>Chúng tôi áp dụng các biện pháp bảo mật để bảo vệ thông tin của bạn:</p>
              <ul>
                <li>Mã hóa dữ liệu truyền tải qua giao thức HTTPS/TLS.</li>
                <li>Mã hóa thông tin xác thực (API token, mật khẩu) trong cơ sở dữ liệu.</li>
                <li>Xác thực JWT với cơ chế refresh token an toàn.</li>
                <li>Giới hạn quyền truy cập dữ liệu theo vai trò người dùng.</li>
                <li>Sao lưu dữ liệu định kỳ và có kế hoạch khôi phục.</li>
              </ul>

              <h2>5. Cookie và lưu trữ cục bộ</h2>
              <p>
                connect.mybota.vn sử dụng cookie và localStorage để duy trì phiên đăng nhập,
                lưu trữ tùy chọn hiển thị (chế độ sáng/tối) và cải thiện trải nghiệm sử dụng.
                Cookie xác thực được bảo vệ với các cờ bảo mật phù hợp.
              </p>

              <h2>6. Quyền của bạn</h2>
              <p>Bạn có các quyền sau đối với thông tin cá nhân của mình:</p>
              <ul>
                <li>Truy cập và xem thông tin tài khoản đã cung cấp.</li>
                <li>Chỉnh sửa, cập nhật thông tin không chính xác.</li>
                <li>Ngắt kết nối các sàn thương mại điện tử và đơn vị vận chuyển.</li>
                <li>Yêu cầu xóa tài khoản và dữ liệu liên quan.</li>
              </ul>

              <h2>7. Lưu trữ dữ liệu</h2>
              <p>
                Dữ liệu của bạn được lưu trữ trên hệ thống máy chủ tại Việt Nam.
                Chúng tôi giữ dữ liệu trong suốt thời gian bạn sử dụng dịch vụ
                và trong khoảng thời gian hợp lý sau khi tài khoản bị xóa để tuân thủ
                nghĩa vụ pháp lý.
              </p>

              <h2>8. Thay đổi chính sách</h2>
              <p>
                Chúng tôi có thể cập nhật chính sách này theo thời gian. Mọi thay đổi quan trọng
                sẽ được thông báo qua email hoặc thông báo trên nền tảng. Việc tiếp tục sử dụng
                dịch vụ sau khi chính sách được cập nhật đồng nghĩa với việc bạn chấp nhận
                các thay đổi đó.
              </p>

              <h2>9. Liên hệ</h2>
              <p>
                Nếu bạn có câu hỏi về chính sách quyền riêng tư này, vui lòng liên hệ:
              </p>
              <ul>
                <li><strong>Email:</strong> contact@bota.com.vn</li>
                <li><strong>Hỗ trợ:</strong> 1900 2008</li>
                <li><strong>Hotline:</strong> 0988 512 772</li>
                <li><strong>Website:</strong> connect.mybota.vn / bota.vn</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <footer className='legal-page-footer'>
        <div className='legal-page-footer-inner'>
          <div className='legal-page-copyright'>
            Copyright &copy; 2023 bota.vn — connect.mybota.vn · Giải pháp quản lý và bán hàng đa kênh toàn diện
          </div>
          <div className='legal-page-links'>
            <a href='/privacy-policy'>Chính sách quyền riêng tư</a>
            <a href='/terms-of-service'>Điều khoản dịch vụ</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
